import { baseAPI } from "../../services/api";
import { transactionID } from "../../services/helpers";

export function cardRechargeRequest({
  msisdn,
  value,
  cvv,
  paymentId,
  authToken,
  program = false,
  installments
}) {
  return baseAPI.post(
    "/v2/recharge",
    {
      transactionId: transactionID("ACI"),
      MSISDN: msisdn,
      SMSISDN: msisdn,
      paymentType: "C",
      paymentId,
      Value: value,
      cvv,
      program,
      ExternalAuthentication: null,
      installments
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
}

// {"code":"P00","msg":"Recarga realizada com sucesso","authenticationUrl":null,"linhaDigitavel":null,"rechargeID":"14055284","pixKey":null,"qrCode":null,"txid":null,"pixExpirationDate":null}
